<template>
  <label :for="creditCardId" class="credit-card" :class="{ iphone: isIPhone }">
    <img v-if="isRecognizedBrand" :src="require(`@/assets/credit-card-brands/${brand}.svg`)"> <span v-else>{{brand.toUpperCase()}}</span> <span class="dots">....</span> <span class="dots">....</span> <span class="dots">....</span> {{last4}}
  </label>
</template>

<script>
export default {
  name: 'CreditCard',

  props: {
    brand: {
      type: String,
      required: true
    },

    last4: {
      type: String,
      required: true
    },

    creditCardId: {
      type: String,
      required: true
    },

    isIPhone: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      recognizedBrands: ["alipay", "amex", "diners", "discover", "elo", "hiper", "hipercard",
        "jcb", "masestro", "mastercard", "mir", "paypal", "unionpay", "visa"]
    }
  },

  computed: {
    isRecognizedBrand() {
      return this.recognizedBrands.includes(this.brand)
    }
  }
}
</script>

<style scoped>
label.credit-card {
  font-size: 12px;
  line-height: 18px;
  display: flex;
}

label.credit-card img {
  max-width: 25px;
  max-height: 21px;
  margin-right: 4px;
}

label.credit-card span {
  margin-right: 4px;
}

label.credit-card span.dots {
  -webkit-text-security: disc;
  font-size: 10px;
}

label.credit-card.iphone span.dots {
  font-size: 6px;
}
</style>
